import { map, clone } from 'lodash';

const endpoint = (property) => `/api/${property}/events/extras`;

export default ['api', '$rootScope', 'categoriesTransformer', function(api, $rootScope, categoriesTransformer) {
  return {
    save: extra => {
      let url = extra.id ? `${ endpoint(api.property()) }/${ extra.id }` : endpoint(api.property());

      return api.upload(url, extra).then(response => response.data);
    },
    delete: id => api.delete(`${ endpoint(api.property()) }/${ id }`),
    findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
      return api.get(endpoint(api.property())+(page ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')+(deleted ? '&deleted=true' : '')).
        then(response => response.data);
    },
    findById: id => {
      return api.get(`${ endpoint(api.property()) }/${ id }`)
        .then(response => response.data);
    },
    search: (type, text, page = null) => {
      return api.get(`${endpoint(api.property())}?type=${type}&text=${text}`+(page ? '&page='+page : '')).then(response => response.data);
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/services/extras.service.js